import React from "react";
import cs from "classnames";

import "./ui.scss";

export interface InfoListItem {
  label: string;
  value?: React.ReactNode;
}

interface Props {
  items: InfoListItem[];
  className?: string;
}

const isMissing = (value: React.ReactNode) =>
  value === undefined || value === null || value === "";

export const InfoList = ({ items, className }: Props) => (
  <dl className={cs("InfoList", className)}>
    {items.map(({ label, value }) => (
      <div key={label} className="InfoList__row">
        <dt className="InfoList__label">{label}</dt>
        <dd className="InfoList__value">{isMissing(value) ? "-" : value}</dd>
      </div>
    ))}
  </dl>
);
